import {Mapper} from '@s-ui/domain'

const MAX_SIZE_PAID_ADS = 5

export default class HttpSearchResultsResponseToAdsListValueObjectMapper extends Mapper {
  constructor({
    adsListValueObjectFactory,
    fromAdAggregationsRawDataToAdAggregationsListValueObjectMapper,
    fromAdRawDataToAdEntityMapper
  }) {
    super()

    // Mappers
    this._fromAdAggregationsRawDataToAdAggregationsListValueObjectMapper =
      fromAdAggregationsRawDataToAdAggregationsListValueObjectMapper
    this._fromAdRawDataToAdEntityMapper = fromAdRawDataToAdEntityMapper
    // Value Objects
    this._adsListValueObjectFactory = adsListValueObjectFactory
    this._RENTING_LISTING_POSITION_VARIATIONS_MAP = {
      variation_1: 0,
      variation_2: 1,
      variation_3: 2
    }
  }

  _getAggregationsListItems({aggregations}) {
    const adAggregationsListValueObject = this._fromAdAggregationsRawDataToAdAggregationsListValueObjectMapper.map({
      items: aggregations
    })

    return adAggregationsListValueObject.getItems()
  }

  map = ({aggregations = [], highlightedAd, items = [], paidItems = [], meta} = {}) => {
    const hasAggregations = Boolean(aggregations) && Boolean(aggregations.length)

    const hasHighlightedAd = Boolean(highlightedAd)

    const paid = paidItems.slice(0, MAX_SIZE_PAID_ADS)
    const topItems = paid.map(item => {
      return {
        ...item,
        isTop: true
      }
    })
    const rawAds = [...topItems, ...items]
    const {totalPages, totalResults} = meta
    const adEntities = rawAds.map(this._fromAdRawDataToAdEntityMapper.map)

    return this._adsListValueObjectFactory({
      ...(hasAggregations && {
        aggregations: this._getAggregationsListItems({aggregations})
      }),
      items: adEntities,
      ...(hasHighlightedAd && {
        highlightedAd: this._fromAdRawDataToAdEntityMapper.map(highlightedAd)
      }),
      totalPages,
      totalResults
    })
  }
}
